import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8161216e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center","height":"24px","margin-bottom":"13px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"16px","font-weight":"500"} }, "签到地址", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#999","font-size":"12px"} }, "（添加后才能签到打卡）", -1))
const _hoisted_5 = { style: {"flex":"1 1 0%","text-align":"right"} }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "flex" }

import { ref, reactive, nextTick, computed, onBeforeMount, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
import { DcConfirm, message } from '@dc-platform/dc-components'
import { cloneDeep } from 'lodash-es'
import { contactValidate, concatNameValidate, selectForNumberValidate } from '@/utils/validate'
import CustomerArea from '@/components/CustomerArea'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { clueTypeEnum } from '@/views/gucangSales/clueManage/dataConfig'
import { contactTypeEnum, linkRoleTypeEnum, genderEnum, flagEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { listByParamCodes, fetchUsersByWorkCode } from '@/api/common'
import { salesClueCreate, salesClueActivate, salesClueEdit } from '@/api/gucangSales/clueManage'
import calc from '@/utils/calc'
import { initObjectVal, clearInvalid, paramCodesDataFilter } from '@/utils/index'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import type { ParamCodeItem } from '@/typings/common'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import MapModal from '@/components/MapModal/index.vue'
import {
  checkAddressValidate,
  checkAddressData,
  handleAddressAdd,
  handleAddressAddDel,
  clear
} from '@/hooks/addressArrValidate'
import CosInputTianyancha from '@/components/Antd/CosInputTianyancha/index.vue'


const __default__ = { name: 'DetailForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: Object,
  isEdit: {
    type: Boolean,
    required: true
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'view'].includes(value)
    }
  },
  clueTypeDisabled: {
    type: Boolean,
    default: false
  },
  resetValue: {
    type: [Object, Array]
  }
},
  setup(__props) {

const router = useRouter()
const route = useRoute()

const props = __props

const permissionPage = computed(() => {
  return props.type === 'add' ? { save: 'fbu_clue_add_btn' } : { edit: 'fbu_clue_edit_btn', save: 'fbu_clue_edit_btn' }
})
const initForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: { demandInfo: { warehouses: [{}] }, saleInfo: [{}] },
  visitAddress: [{}]
})

const queryClueId = computed(() => route.query.clueId as string)
// 线索类型枚举
const clueTypeEnumComputed = computed(() => {
  const addList = clueTypeEnum.filter((item) => item.value === 1 || item.value === 2)
  const otherList = clueTypeEnum.filter((item) => item.value)
  return props.type === 'add' ? addList : otherList
})
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  fbu_invalid_reason: [], // 无效原因
  fbu_marketing_activity: [], // 关联市场活动
  fbu_area_code: [], // 手机区号
  fbu_service_demand: [], // 服务需求
  fbu_important: [], // 潜在收入
  fbu_demand_info: [], // 需求海外仓
  fbu_sale_platform: [], // 在售电商平台
  fbu_sales_category: [], // 销售品类
  fbu_product_type: [], // 产品货型
  fbu_customer_category: [] // 客户类别
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: [
      'fbu_invalid_reason',
      'fbu_marketing_activity',
      'fbu_area_code',
      'fbu_service_demand',
      'fbu_important',
      'fbu_demand_info',
      'fbu_sale_platform',
      'fbu_sales_category',
      'fbu_product_type',
      'fbu_sign_in_address_label',
      'fbu_industrial_belt',
      'fbu_customer_category'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    Object.assign(paramCodeData, res.data)
  })
}
onBeforeMount(() => {
  getByParamCodes()
})
// 获取当前用户的信息
const getFollowerInfo = (workCode: string) => {
  const employeeList = [workCode]
  fetchUsersByWorkCode({ employeeList }).then((res) => {
    const [followerInfo] = res.data
    if (followerInfo && followerInfo.fbuCustomerRegion != null) {
      dataForm.customerRegion = followerInfo.fbuCustomerRegion
    } else {
      dataForm.customerRegion = undefined
      setTimeout(() => formRef.value?.clearValidate('customerRegion'))
    }
  })
}
/// 文本识别
const clipParseInfo = (parseInfo: any) => {
  if (!parseInfo) {
    return
  }
  let allBlank = false
  if (!dataForm.contact.name && !dataForm.customerAddress && !dataForm.contact.mobile && !dataForm.remark) {
    allBlank = true
  }
  if (allBlank) {
    dataForm.contact.name = parseInfo.contactName
    dataForm.customerAddress = parseInfo.address
    dataForm.contact.mobile = parseInfo.phoneNum
    dataForm.remark = parseInfo.detail
    return
  }
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否替换原内容',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      dataForm.contact.name = parseInfo.contactName
      dataForm.customerAddress = parseInfo.address
      dataForm.contact.mobile = parseInfo.phoneNum
      dataForm.remark = parseInfo.detail
    }
  })
}
const formRef = ref<FormInstance>()
const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))
const clueType = ref(false)
const invalidClue = ref(false)
const isPerfect = ref(false)
const formRules: Record<string, Rule[]> = {
  select: [{ required: true, message: '请选择' }],
  selectForNumber: [{ required: true, validator: selectForNumberValidate, message: '请选择' }],
  input: [{ required: true, message: '请输入' }],
  channel: [{ required: true, message: '请选择线索来源' }],
  clueType: [{ required: true, validator: selectForNumberValidate, message: '请选择线索类型' }],
  customerOffice: [{ required: true, message: '请选择客户办公地' }],
  futureContactTime: [{ required: true, message: '请选择未来联系时间' }],
  follower: [{ required: true, message: '请选择客户负责人' }],
  customerName: [{ required: true, message: '请输入客户名称' }],
  industrialBeltName: [{ required: true, message: '请输入产业带名称' }],
  invalidId: [{ required: true, validator: selectForNumberValidate, message: '请选择无效原因' }],
  contactType: [{ required: true, validator: selectForNumberValidate, message: '请选择联系人类型' }],
  name: [
    { required: true, message: '请输入联系人姓名' },
    {
      validator: concatNameValidate
    }
  ],
  contact: [{ validator: (rule: any, value: any) => contactValidate(rule, value, dataForm, formRef.value) }]
}
watch(
  () => route.query.isPerfect,
  (val) => {
    if (val === 'required') {
      isPerfect.value = true
    }
  },
  { immediate: true }
)
watch(
  () => dataForm.clueType,
  (val) => {
    // 控制未来线索必填校验
    if (val === 1) {
      clueType.value = true
    } else {
      clueType.value = false
      dataForm.futureContactTime = undefined
    }

    // 控制无效线索必填校验
    if (val === 3) {
      invalidClue.value = true
    } else {
      invalidClue.value = false
      dataForm.invalidId = undefined
    }
  },
  { immediate: true }
)
watch(
  () => props.value,
  (val) => {
    if (val) {
      // 处理后端返回 null、0、空数组的问题
      const formVal = {
        ...val
      }
      initObjectVal(formVal, initForm)
      // 处理需求海外仓和totalAmount 把0=》undefined
      if (!formVal.business.demandInfo.totalAmount) {
        formVal.business.demandInfo.totalAmount = undefined
      }
      if (formVal.business.demandInfo.warehouses.length) {
        formVal.business.demandInfo.warehouses.forEach((item: any) => {
          if (!item) return
          if (item.warehouseId != null) {
            item.warehouseId = item.warehouseId || undefined
          }
          if (item.amount === null) item.amount = undefined
        })
      }
      if (formVal.business.saleInfo.length) {
        formVal.business.saleInfo.forEach((item: any) => {
          if (!item) return
          if (item.salePlatformId != null) {
            item.salePlatformId = item.salePlatformId || undefined
          }
          if (item.percent === null) item.percent = undefined
        })
      }
      Object.assign(dataForm, clearInvalid(formVal))
    }
  },
  { immediate: true, deep: true }
)

const clearMainAddressFlag = (index: number) => {
  if (dataForm.visitAddress) {
    for (const [i, item] of dataForm.visitAddress.entries()) {
      if (index === i) {
        item.mainAddressFlag = item.mainAddressFlag === 1 ? 0 : 1
      } else {
        item.mainAddressFlag = 0
      }
    }
  }
}

const handleFollowerChange = (val: any) => {
  if (val && props.type === 'add') getFollowerInfo(val)
}

const goBack = () => {
  if (location.hostname === 'localhost') {
    router.back()
  } else {
    layoutTags.close()
  }
}
const changeIndustrialBeltFlag = () => {
  const { industrialBeltFlag } = dataForm.business
  if (industrialBeltFlag === 0) {
    dataForm.business.industrialBelt = -9
    dataForm.business.industrialBeltLabel = ''
    dataForm.business.industrialBeltName = ''
  }
}
const changeIndustrialBeltLabel = () => {
  nextTick(() => {
    const { industrialBeltLabel } = dataForm.business
    if (industrialBeltLabel && industrialBeltLabel !== '其他') {
      dataForm.business.industrialBeltName = ''
    }
  })
}
const checkValidate = (rule: any, value: number | string, arr: any, name: string, message: string) => {
  if (isPerfect.value && value == null) return Promise.reject(new Error(message))
  const index = rule.field.split('.').slice(-2)[0] * 1
  const list = arr || []
  let key = list[index][name]
  if (name === 'warehouseId' && key === -9) key = undefined
  if (key != null && key !== '' && (!value || value === -9)) {
    return Promise.reject(new Error(message))
  } else {
    return Promise.resolve()
  }
}
const percentValidate = async (rule: any, value: number) => {
  if (isPerfect.value && value == null) return Promise.reject(new Error('请输入平台销量占比'))
  const index = rule.field.split('.').slice(-2)[0] * 1
  const key = dataForm.business.saleInfo?.[index].salePlatformId
  if (key && key !== -9 && value == null) {
    return Promise.reject(new Error('请输入平台销量占比'))
  }
  const result = dataForm.business.saleInfo?.reduce((prev: number, curr: any) => calc.Add(prev, curr.percent || 0), 0)
  if (value && result !== 100) {
    return Promise.reject(new Error('在售平台占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}

const amount = computed(() => {
  const result = dataForm.business.demandInfo.warehouses?.reduce((sum, item) => {
    return calc.Add(sum, item.amount || 0)
  }, 0)
  return result || ''
})
const handleWarehouseAdd = () => {
  dataForm.business.demandInfo.warehouses?.push({ warehouseId: undefined, amount: undefined })
}
const handleWarehouseDel = (index: number) => {
  dataForm.business.demandInfo.warehouses?.splice(index, 1)
}
const handleSalePlatformAdd = () => {
  dataForm.business.saleInfo?.push({ salePlatformId: undefined, percent: undefined })
}
const handleSalePlatformDel = (index: number) => {
  dataForm.business.saleInfo?.splice(index, 1)
}

const loading = ref(false)
const handleSubmit = async () => {
  try {
    loading.value = true
    const params = cloneDeep(dataForm)
    // 地址为空清除、判断地址是否重复
    if (checkAddressData(dataForm.visitAddress)) {
      message.error('签到地址不可重复！')
      loading.value = false
      return false
    }
    const { visitAddress } = params
    params.visitAddress = clear(visitAddress, ['addressName', 'geoPoint'])
    // 新增、编辑的格式和详情不同、多传attrList
    if (JSON.stringify(params.visitAddress) === '[{}]') {
      params.visitAddress = { attrList: [] }
    } else {
      params.visitAddress = { attrList: params.visitAddress }
    }
    // 联系方式为空的字段需要删除，否则接口会报错
    // for (const key in params.contact) {
    //   if (params.contact[key] === '' || params.contact[key] == null) delete params.contact[key]
    // }
    params.business.demandInfo.warehouses = params.business.demandInfo.warehouses?.filter((item: any) => {
      return item.warehouseId != null && item.amount != null
    })
    params.business.saleInfo = params.business.saleInfo?.filter((item: any) => {
      return item.salePlatformId != null && item.percent != null
    })
    // 清空产业带名称
    if (params.business.industrialBeltFlag !== 1) {
      params.business.industrialBeltName = ''
    }
    if (queryClueId.value) {
      params.id = queryClueId.value
      if (params.customerRegion === undefined) {
        params.customerRegion = ''
      }
      await salesClueEdit(params)
      message.success('修改线索成功')
      goBack()
    } else {
      const data = await salesClueCreate(params, { custom: { errorMsg: false } })
      if (data.code === 200) {
        message.success('新增线索成功')
        goBack()
      } else if (data.code === 13000059) {
        DcConfirm.warning({
          title: '操作提示！',
          content: data.message,
          cancelText: '取消',
          okText: '继续',
          onOk() {
            salesClueActivate(params).then(() => {
              message.success('新增线索抢占成功')
              goBack()
            })
          }
        })
      } else {
        message.error(data.message)
      }
    }
  } catch (errorInfo: any) {
    loading.value = false
    formRef.value?.scrollToField(errorInfo.errorFields[0].name.toString())
  }
  loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_CosRadioGroup = _resolveComponent("CosRadioGroup")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      model: dataForm,
      rules: formRules,
      autocomplete: "off",
      scrollToFirstError: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, {
          title: "基础信息",
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              name: "customerName",
              label: "客户名称"
            }, {
              default: _withCtx(() => [
                _createVNode(CosInputTianyancha, {
                  appId: "cos_fbu",
                  value: dataForm.customerName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.customerName) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            (props.type === 'view')
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  name: "customerName",
                  label: "线索ID"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.clueId,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.clueId) = $event)),
                      disabled: !props.isEdit,
                      view: ""
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              name: "channel",
              label: "线索来源",
              class: "form-item_compact"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, {
                  compact: "",
                  class: "cos-view-input-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ParamCodeCascader, {
                      value: dataForm.channel,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.channel) = $event)),
                      cosDes: dataForm.channelExplain,
                      appId: "cos_fbu",
                      paramCode: "fbu_source_channel",
                      status: props.type === 'view' ? undefined : 0,
                      disabled: !props.isEdit,
                      view: props.type === 'view',
                      style: {"width":"33%"}
                    }, null, 8, ["value", "cosDes", "status", "disabled", "view"]),
                    _createVNode(_component_dc_form_item, {
                      name: "channelExplain",
                      span: 24,
                      style: {"width":"67%"},
                      class: "last-compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosInput, {
                          value: dataForm.channelExplain,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.channelExplain) = $event)),
                          maxlength: 100,
                          disabled: !props.isEdit,
                          view: props.type === 'view'
                        }, null, 8, ["value", "disabled", "view"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              name: "clueType",
              label: "线索类型"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: dataForm.clueType,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.clueType) = $event)),
                  options: clueTypeEnumComputed.value,
                  disabled: !props.isEdit || props.clueTypeDisabled,
                  view: props.type === 'view',
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              name: "customerOffice",
              label: "客户办公地",
              rules: isPerfect.value ? formRules.customerOffice : []
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CustomerArea), {
                  value: dataForm.customerOffice,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.customerOffice) = $event)),
                  "change-on-select": "",
                  showSearch: "",
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              name: "customerAddress",
              label: "客户详细地址"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.customerAddress,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.customerAddress) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  placeholder: "请输入",
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              name: "marketActivity",
              label: "关联市场活动"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.marketActivity,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.marketActivity) = $event)),
                  options: paramCodeData.fbu_marketing_activity,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              name: "customerRegion",
              label: "客户区域"
            }, {
              default: _withCtx(() => [
                _createVNode(CustomerAreaCascader, {
                  appId: "cos_fbu",
                  value: dataForm.customerRegion,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((dataForm.customerRegion) = $event)),
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            (clueType.value)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 1,
                  name: "futureContactTime",
                  label: "未来联系时间",
                  rules: clueType.value ? formRules.futureContactTime : []
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosSingleDateTimePicker, {
                      startTime: dataForm.futureContactTime,
                      "onUpdate:startTime": _cache[9] || (_cache[9] = ($event: any) => ((dataForm.futureContactTime) = $event)),
                      isRange: false,
                      view: props.type === 'view'
                    }, null, 8, ["startTime", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              name: "follower",
              label: "客户负责人"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  value: dataForm.follower,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((dataForm.follower) = $event)),
                  defaultValue: "me",
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  onChange: handleFollowerChange
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            (dataForm.clueType === 3)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 2,
                  name: "invalidId",
                  label: "无效原因",
                  rules: invalidClue.value ? formRules.invalidId : []
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: dataForm.invalidId,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((dataForm.invalidId) = $event)),
                      options: paramCodeData.fbu_invalid_reason,
                      disabled: !props.isEdit,
                      view: props.type === 'view',
                      allowClear: ""
                    }, null, 8, ["value", "options", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]))
              : _createCommentVNode("", true),
            (!props.isEdit)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 3,
                  name: "createByName",
                  label: "创建人"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.createByName,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((dataForm.createByName) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!props.isEdit)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 4,
                  name: "createTime",
                  label: "创建时间"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.createTime,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((dataForm.createTime) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              name: "contactStartTime",
              label: "联系时间"
            }, {
              default: _withCtx(() => [
                _createVNode(CosSingleDateTimePicker, {
                  startTime: dataForm.contactStartTime,
                  "onUpdate:startTime": _cache[14] || (_cache[14] = ($event: any) => ((dataForm.contactStartTime) = $event)),
                  endTime: dataForm.contactEndTime,
                  "onUpdate:endTime": _cache[15] || (_cache[15] = ($event: any) => ((dataForm.contactEndTime) = $event)),
                  isRange: true,
                  view: props.type === 'view'
                }, null, 8, ["startTime", "endTime", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              name: "remindFlag",
              label: "提醒他处理线索"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: dataForm.remindFlag,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((dataForm.remindFlag) = $event)),
                  view: props.type === 'view',
                  options: _unref(flagEnum)
                }, null, 8, ["value", "view", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              name: "remark",
              label: "备注",
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: dataForm.remark,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((dataForm.remark) = $event)),
                  maxlength: 2000,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, {
          title: "联系人信息",
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "联系人类型",
              name: ['contact', 'contactType'],
              rules: formRules.contactType
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: dataForm.contact.contactType,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((dataForm.contact.contactType) = $event)),
                  options: _unref(contactTypeEnum),
                  disabled: !props.isEdit,
                  allowClear: "",
                  view: props.type === 'view'
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "联系人姓名",
              name: ['contact', 'name'],
              rules: formRules.name
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.contact.name,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((dataForm.contact.name) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "手机号",
              name: ['contact', 'mobileRegion'],
              class: "form-item_compact"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, {
                  compact: "",
                  class: "cos-view-input-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: dataForm.contact.mobileRegion,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((dataForm.contact.mobileRegion) = $event)),
                      options: paramCodeData.fbu_area_code,
                      disabled: !props.isEdit,
                      view: props.type === 'view',
                      cosDes: dataForm.contact.mobile,
                      allowClear: "",
                      style: {"width":"33%"}
                    }, null, 8, ["value", "options", "disabled", "view", "cosDes"]),
                    _createVNode(_component_dc_form_item, {
                      span: 24,
                      style: {"width":"67%"},
                      name: ['contact', 'mobile'],
                      rules: {
              validator: (rule, value) => _unref(contactValidate)(rule, value, dataForm.contact, formRef.value)
            },
                      class: "last-compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosInput, {
                          value: dataForm.contact.mobile,
                          "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((dataForm.contact.mobile) = $event)),
                          disabled: !props.isEdit,
                          view: props.type === 'view'
                        }, null, 8, ["value", "disabled", "view"])
                      ]),
                      _: 1
                    }, 8, ["rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "微信号",
              name: ['contact', 'wechat'],
              rules: {
              validator: (rule, value) => _unref(contactValidate)(rule, value, dataForm.contact, formRef.value)
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.contact.wechat,
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((dataForm.contact.wechat) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "QQ号",
              name: ['contact', 'qq'],
              rules: {
              validator: (rule, value) => _unref(contactValidate)(rule, value, dataForm.contact, formRef.value)
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.contact.qq,
                  "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((dataForm.contact.qq) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "邮箱",
              name: ['contact', 'email'],
              rules: {
              validator: (rule, value) => _unref(contactValidate)(rule, value, dataForm.contact, formRef.value)
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.contact.email,
                  "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((dataForm.contact.email) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "固定电话",
              name: ['contact', 'telRegion'],
              class: "form-item_compact"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, {
                  compact: "",
                  class: "cos-view-input-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: dataForm.contact.telRegion,
                      "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((dataForm.contact.telRegion) = $event)),
                      options: paramCodeData.fbu_area_code,
                      disabled: !props.isEdit,
                      view: props.type === 'view',
                      cosDes: dataForm.contact.tel,
                      allowClear: "",
                      style: {"width":"33%"}
                    }, null, 8, ["value", "options", "disabled", "view", "cosDes"]),
                    _createVNode(_component_dc_form_item, {
                      span: 24,
                      style: {"width":"67%"},
                      name: ['contact', 'tel'],
                      rules: {
              validator: (rule, value) => _unref(contactValidate)(rule, value, dataForm.contact, formRef.value)
            },
                      class: "last-compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosInput, {
                          value: dataForm.contact.tel,
                          "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((dataForm.contact.tel) = $event)),
                          maxlength: 100,
                          disabled: !props.isEdit,
                          view: props.type === 'view'
                        }, null, 8, ["value", "disabled", "view"])
                      ]),
                      _: 1
                    }, 8, ["rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "角色",
              name: ['contact', 'tel']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: dataForm.contact.jobRole,
                  "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((dataForm.contact.jobRole) = $event)),
                  options: _unref(linkRoleTypeEnum),
                  disabled: !props.isEdit,
                  allowClear: "",
                  view: props.type === 'view'
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "部门职务",
              name: ['contact', 'jobDuty']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.contact.jobDuty,
                  "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((dataForm.contact.jobDuty) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "性别",
              name: ['contact', 'sex'],
              span: 18
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: dataForm.contact.sex,
                  "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((dataForm.contact.sex) = $event)),
                  options: _unref(genderEnum),
                  view: props.type === 'view'
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: "备注",
              name: ['contact', 'remark'],
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: dataForm.contact.remark,
                  "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((dataForm.contact.remark) = $event)),
                  maxlength: 2000,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, {
          title: "签到地址（添加后才能签到打卡）",
          span: 6
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                (props.isEdit)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      ghost: "",
                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_unref(handleAddressAdd)(dataForm.visitAddress)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新增")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: props.type === 'view',
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.visitAddress, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '签到地址',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['visitAddress', index, 'addressName'],
                      rules: [
            { validator: (rule, value) => _unref(checkAddressValidate)(rule, value, dataForm.visitAddress, 'addressTag', '请选择') }
          ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(MapModal, {
                          address: item.addressName,
                          "onUpdate:address": ($event: any) => ((item.addressName) = $event),
                          geoPoint: item.geoPoint,
                          "onUpdate:geoPoint": ($event: any) => ((item.geoPoint) = $event),
                          view: props.type === 'view'
                        }, null, 8, ["address", "onUpdate:address", "geoPoint", "onUpdate:geoPoint", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '地址类型',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['visitAddress', index, 'addressTag'],
                      rules: [
            { validator: (rule, value) => _unref(checkAddressValidate)(rule, value, dataForm.visitAddress, 'addressName', '请输入') }
          ]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.fbu_sign_in_address_label,
                            value: item.addressTag,
                            "onUpdate:value": ($event: any) => ((item.addressTag) = $event),
                            disabled: !props.isEdit,
                            view: props.type === 'view',
                            allowClear: "",
                            style: {"width":"100%"}
                          }, null, 8, ["options", "value", "onUpdate:value", "disabled", "view"]),
                          (props.isEdit && dataForm.visitAddress && dataForm.visitAddress.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (_unref(handleAddressAddDel)(index, dataForm.visitAddress))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_checkbox, {
                            style: {"padding":"3px 0 0 12px","width":"150px"},
                            disabled: props.type === 'view',
                            checked: item.mainAddressFlag === 1,
                            onChange: ($event: any) => (clearMainAddressFlag(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("主要")
                            ]),
                            _: 2
                          }, 1032, ["disabled", "checked", "onChange"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, {
          title: "物流需求",
          span: 6
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "服务需求",
              name: ['business', 'demandInfo', 'demandIds'],
              rules: isPerfect.value ? formRules.select : []
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.demandInfo.demandIds,
                  "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((dataForm.business.demandInfo.demandIds) = $event)),
                  options: paramCodeData.fbu_service_demand,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, { label: "海外仓月消费总额（销售预估/万元）" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: amount.value,
                  "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((amount).value = $event)),
                  valueModifiers: { trim: true },
                  disabled: "",
                  view: props.type === 'view',
                  placeholder: "自动计算"
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "海外仓月消费总额（市场预估）",
              name: ['business', 'demandInfo', 'totalAmount'],
              rules: isPerfect.value ? [{ required: true, validator: _unref(selectForNumberValidate) }] : []
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.demandInfo.totalAmount,
                  "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((dataForm.business.demandInfo.totalAmount) = $event)),
                  options: paramCodeData.fbu_important,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(MultipleItem, {
              view: props.type === 'view'
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.business.demandInfo.warehouses, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '需求海外仓',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'demandInfo', 'warehouses', index, 'warehouseId'],
                      rules: [{ required: isPerfect.value, validator: (rule, value) => checkValidate(rule, value, dataForm.business.demandInfo.warehouses, 'amount', '请选择') }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          value: item.warehouseId,
                          "onUpdate:value": ($event: any) => ((item.warehouseId) = $event),
                          options: paramCodeData.fbu_demand_info,
                          disabled: !props.isEdit,
                          view: props.type === 'view',
                          allowClear: ""
                        }, null, 8, ["value", "onUpdate:value", "options", "disabled", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '月消费额(万)',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'demandInfo', 'warehouses', index, 'amount'],
                      rules: [{ required: isPerfect.value, validator: (rule, value) => checkValidate(rule, value, dataForm.business.demandInfo.warehouses, 'warehouseId', '请输入') }]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_CosInputNumber, {
                            value: item.amount,
                            "onUpdate:value": ($event: any) => ((item.amount) = $event),
                            min: 0,
                            maxlength: 15,
                            disabled: !props.isEdit,
                            view: props.type === 'view',
                            style: {"width":"100%"}
                          }, null, 8, ["value", "onUpdate:value", "disabled", "view"]),
                          (
                  props.isEdit &&
                  dataForm.business.demandInfo.warehouses &&
                  dataForm.business.demandInfo.warehouses.length > 1
                )
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (handleWarehouseDel(index))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 2
        }, [
          (props.isEdit)
            ? {
                name: "subTitle",
                fn: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _cache[32] || (_cache[32] = ($event: any) => (handleWarehouseAdd()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1024),
        _createVNode(_component_dc_layout_card, {
          title: "客户业务",
          span: 6
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "销售平台(市场)",
              name: ['business', 'salePlatform'],
              rules: isPerfect.value ? formRules.select : []
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.salePlatform,
                  "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((dataForm.business.salePlatform) = $event)),
                  options: paramCodeData.fbu_sale_platform,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "销售品类",
              name: ['business', 'salesCategory'],
              rules: isPerfect.value ? formRules.select : []
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.salesCategory,
                  "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((dataForm.business.salesCategory) = $event)),
                  options: paramCodeData.fbu_sales_category,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "产品货型",
              name: ['business', 'cargoType'],
              rules: isPerfect.value ? formRules.select : []
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.cargoType,
                  "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((dataForm.business.cargoType) = $event)),
                  options: paramCodeData.fbu_product_type,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "客户类别",
              name: ['business', 'customerCategory'],
              rules: formRules.select
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.customerCategory,
                  "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((dataForm.business.customerCategory) = $event)),
                  options: paramCodeData.fbu_customer_category,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "是否产业带",
              name: ['business', 'industrialBeltFlag'],
              rules: formRules.select
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: dataForm.business.industrialBeltFlag,
                  "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((dataForm.business.industrialBeltFlag) = $event)),
                  options: _unref(flagEnum),
                  onChange: changeIndustrialBeltFlag,
                  view: props.type === 'view'
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            (dataForm.business.industrialBeltFlag === 1)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  label: "产业带",
                  name: ['business', 'industrialBelt'],
                  rules: formRules.selectForNumber
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      options: paramCodeData.fbu_industrial_belt,
                      value: dataForm.business.industrialBelt,
                      "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((dataForm.business.industrialBelt) = $event)),
                      label: dataForm.business.industrialBeltLabel,
                      "onUpdate:label": _cache[43] || (_cache[43] = ($event: any) => ((dataForm.business.industrialBeltLabel) = $event)),
                      view: props.type === 'view',
                      onChange: changeIndustrialBeltLabel
                    }, null, 8, ["options", "value", "label", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]))
              : _createCommentVNode("", true),
            (dataForm.business.industrialBelt && dataForm.business.industrialBeltLabel === '其他')
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 1,
                  label: "产业带名称",
                  name: ['business', 'industrialBeltName'],
                  rules: {
          message: '请输入',
          required: true
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.business.industrialBeltName,
                      "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((dataForm.business.industrialBeltName) = $event)),
                      maxlength: 100,
                      placeholder: "请输入",
                      view: props.type === 'view'
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(MultipleItem, {
              view: props.type === 'view'
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.business.saleInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '在售电商平台',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'saleInfo', index, 'salePlatformId'],
                      rules: [{ required: isPerfect.value, validator: (rule, value) => checkValidate(rule, value, dataForm.business.saleInfo, 'percent', '请选择') }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          value: item.salePlatformId,
                          "onUpdate:value": ($event: any) => ((item.salePlatformId) = $event),
                          options: paramCodeData.fbu_sale_platform,
                          disabled: !props.isEdit,
                          view: props.type === 'view',
                          allowClear: ""
                        }, null, 8, ["value", "onUpdate:value", "options", "disabled", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '平台销量占比(%)',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'saleInfo', index, 'percent'],
                      rules: [{ required: isPerfect.value, validator: percentValidate }]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_CosInputNumber, {
                            value: item.percent,
                            "onUpdate:value": ($event: any) => ((item.percent) = $event),
                            min: 0,
                            disabled: !props.isEdit,
                            view: props.type === 'view',
                            style: {"width":"100%"}
                          }, null, 8, ["value", "onUpdate:value", "disabled", "view"]),
                          (props.isEdit && dataForm.business.saleInfo && dataForm.business.saleInfo.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (handleSalePlatformDel(index))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 2
        }, [
          (props.isEdit)
            ? {
                name: "subTitle",
                fn: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _cache[36] || (_cache[36] = ($event: any) => (handleSalePlatformAdd()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1024)
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_cos_footer_button, {
      value: dataForm,
      "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((dataForm) = $event)),
      formRef: formRef.value,
      resetValue: __props.resetValue,
      loading: loading.value,
      disabled: !props.isEdit,
      permissionPage: permissionPage.value,
      onSubmit: handleSubmit
    }, null, 8, ["value", "formRef", "resetValue", "loading", "disabled", "permissionPage"])
  ], 64))
}
}

})